//@flow

import React from 'react';

import { truncateText } from '../../../lib/utils';
import { LETTER_COUNT_FOR_DESC } from '../../../constants/lettersCount';

type DescriptionProps = { description: string };

const Description = (props: DescriptionProps) => (
  <p>{truncateText(props.description, LETTER_COUNT_FOR_DESC)}</p>
);

export default Description;



// WEBPACK FOOTER //
// ./src/components/Cards/Common/Description.jsx